<script lang="ts" setup>
import { api } from "@/api/api.ts";
import { notify } from "@kyvg/vue3-notification";
import { useGlobalStore } from "@/store/globals.ts";
import backendURLToColor from "@/utils/backendURLToColor.ts";
import qs from "qs";
import { computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const globals = useGlobalStore();
const version = import.meta.env.VITE_APP_VERSION;

const urlColor = computed(() => backendURLToColor(api.baseURL.value));

function copyCurrentURL(): void {
  if (navigator.clipboard) {
    const currentQuery = qs.parse(window.location.search, {
      ignoreQueryPrefix: true,
    });
    const newQuery = { ...currentQuery, backendURL: api.baseURL.value };
    const newSearch = qs.stringify(newQuery, { addQueryPrefix: true });
    const url = `${window.location.origin}${window.location.pathname}${newSearch}`;

    void navigator.clipboard.writeText(url);
    notify({
      title: "URL kopiert",
      text: url,
    });
  }
}
</script>

<template>
  <div
    class="desktop:flex-row desktop:gap-4 desktop:text-left flex w-full flex-col justify-end gap-1 bg-transparent py-1 text-right text-sm"
  >
    <RouterLink
      v-if="route.fullPath !== '/config' && globals.showAPIConfig"
      :to="{ name: 'config' }"
      class="grow"
    >
      <IconFA
        class="desktop:mr-5 focus:outline-hidden ml-1 aspect-square cursor-pointer text-lg text-gray-400 transition"
        icon="gear"
      />
    </RouterLink>
    <template v-if="globals.showAPIConfig">
      <button
        :style="{ color: urlColor }"
        class="text-gray-400 hover:underline"
        @click="copyCurrentURL"
      >
        {{ api.baseURL.value }} <IconFA icon="copy" />
      </button>
      <IconFA
        v-if="globals.isDesktop"
        class="w-2 self-center text-gray-400"
        icon="minus"
      />
    </template>
    <p class="text-gray-400">Version {{ version }}</p>
    <IconFA
      v-if="globals.isDesktop"
      class="w-2 self-center text-gray-400"
      icon="minus"
    />
    <a
      class="text-gray-400"
      href="https://www.curasoft.de/datenschutzerklaerung/"
    >
      Datenschutz
    </a>
    <IconFA
      v-if="globals.isDesktop"
      class="w-2 self-center text-gray-400"
      icon="minus"
    />
    <a class="text-gray-400" href="https://www.curasoft.de/impressum/">
      Impressum
    </a>
  </div>
</template>
